// extracted by mini-css-extract-plugin
export var masthead = "masthead-module--masthead--3125d";
export var mastheadSubtitle = "masthead-module--masthead-subtitle--e1488";
export var mastheadTitle = "masthead-module--masthead-title--1227f";